import http from "../../http";
import { isArray } from "util";
import { sendClassWorkCheckLog } from './log'
import { existInLibrary } from '../libraries/index'

/**
 * 比较两个资源数组的差异以确定需要向服务器存储的资源
 * @param {array<Asset>} 新的资源数组
 * @param {array<id>} 已存在的资源的id
 * @param {array<Asset>} 需要更新的资源数组
 */
export const diffAssets = (newAssets, assetsIds) => (
    newAssets.filter(newAsset => assetsIds.indexOf(newAsset.assetId) === -1)
)
/**
 * 增加已经存在的资源
 */
export const addAsset = (assetID) => {
    if(!window.xesAssets){
      window.xesAssets = {}
    }
    window.xesAssets[assetID]=true
}

/**
 * 查看资源是否存在
 */
export const hasAsset = (assetID) => {
    if(!window.xesAssets){
      window.xesAssets = {}
    }
    if(window.xesAssets[assetID] ===true || existInLibrary(assetID)){
      return true
    }
    return false
}

export const postAssets = (assets) => {
    return Promise.all(
        assets.map(asset =>
          {
            if(!hasAsset(asset.assetId)){
              return http.uploadBase64({
                name: `${asset.assetId}.${asset.dataFormat}`,
                file: asset.encodeDataURI()
              }).then(() => {
                addAsset(asset.assetId)
              })
            } else {
              return Promise.resolve()
            }
          }
        )
      )
}
/**
 * get query
 * @param {name:[string, array]}
 * @parame defaultValue
 * @parame costumeSourceUrl 自定义任意url
 * @return {string} when name is string return result of then name, name is array ['all'] return all the query
 */
export const getQuery = (name, defaultValue, costumeSourceUrl) => {
    let types = {
      ALL: 0,
      ONE: 1
    }
    let type = isArray(name) && name[0] === 'all' ? types.ALL : types.ONE
    let hashString = costumeSourceUrl || window.location.search
    // 防止没有
    if(!hashString){
      // console.log('getQuery '+name+' default:',defaultValue)
      return defaultValue?defaultValue:null
    }
    let strHash = hashString.split('?')[1]
    let i
    let val
    let params = strHash.split('&')
    let query = {}
    for (i = 0; i < params.length; i++) {
      val = params[i].split('=')
      if (type === types.ALL) {
        query[val[0]] = decodeURIComponent(val[1])
        continue
      }
      if (val[0] === name && type === types.ONE) {
        return decodeURIComponent(val[1])
      }
    }
    return type === types.ALL ? query : (defaultValue?defaultValue:null)
}
export const getParamsFromQuery = (names) => {
  if (names === 'all') {
    return getQuery([names])
  }
  let ret = {}
  names.forEach(name => {
    Object.assign(ret, {
      [name]: getQuery(name) || 'null'
    })
  })
  return ret
}
export const xesCookie = {

  setCookie: function (cookiename, cookievalue, days) {
    var date = new Date()
    date.setTime(date.getTime() + Number(days) * 24 * 3600 * 1000)
    document.cookie =
      cookiename +
      '=' +
      escape(cookievalue) +
      '; path=/;expires = ' +
      date.toGMTString() +
      '; domain='
  },
  getCookie: function (cookiename) {
    var nameEQ = cookiename + '='
    var ca = document.cookie.split(';') //  把cookie分割成组
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i] //  取得字符串
      while (c.charAt(0) === ' ') {
        //  判断一下字符串有没有前导空格
        c = c.substring(1, c.length) // 有的话，从第二位开始取
      }
      if (c.indexOf(nameEQ) === 0) {
        //  如果含有我们要的name
        return unescape(c.substring(nameEQ.length, c.length)) //    解码并截取我们要值
      }
    }
    return false
  },
}

const sliceObject = (keyArray, targetObj) => {
  let ret = {};
  keyArray.forEach(key => {
    if (!targetObj.hasOwnProperty(key)) {
      ret[key] = null
    }
    ret[key] = targetObj[key] //浅复制
  })
  return ret
}
const serializeObject = (obj) => {
  let queryElements = Object.keys(obj).map(key => {
    return `${key}=${obj[key]}`
  })
  return queryElements.join('&')
}
class Base64 {
  static encode(data) {
    return window.btoa(data)
  }
  static decode(data) {
    return window.atob(data)
  }
}

const isNumber = (val) => {

  var regPos = /^\d+(\.\d+)?$/; //非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
  if(regPos.test(val) || regNeg.test(val)){
      return true;
  }else{
      return false;
  }

}

const setDOMElementStyle = (element, styles) => {
  Object.keys(styles).forEach(styleName => {
    element.style[styleName] = styles[styleName]
  })
}
const genFullScreenLayer = (id) => {
  let layer = document.createElement('div')
  setDOMElementStyle(layer, {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    opacity: 0,
    zIndex: 10000
  })
  return layer
}

const disableSafariScale = () => {
  document.documentElement.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }, false);
  let lastTouchEnd = 0;
  document.documentElement.addEventListener('touchend', function (event) {
    var now = Date.now();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, false);
}

const isPointInRect = (rect, point) => {
  const xr = (point.x - rect.p1.x) * (point.x - rect.p2.x)
  const yr = (point.y - rect.p1.y) * (point.y - rect.p2.y)
  return xr <= 0 && yr <= 0
  
}
const isCursorInElement = (coords, element) => {
  const clientRect = element.getClientRects()[0]
  return isPointInRect({
    p1: {
      x: clientRect.left,
      y: clientRect.top
    },
    p2: {
      x: clientRect.left + clientRect.width,
      y: clientRect.top + clientRect.height
    }
  }, coords)
}

const simMouseEnterOut = (element, handleMouseEnter, handleMouseLeave) => {
  let wasCursorIn = false
  return function (e) {
    let isCursorIn = isCursorInElement({
        x: e.touches[0].clientX,
        y: e.touches[0].clientY
    }, element)
    if (isCursorIn && !wasCursorIn) {
        handleMouseEnter()
    }
    if (!isCursorIn && wasCursorIn) {
        handleMouseLeave()
    }
    wasCursorIn = isCursorIn
  }
}

class MouseEnterOutSimulator {
  constructor(element, handleMouseEnter, handleMouseLeave) {
    if (!element) return
    this._uid = MouseEnterOutSimulator._uid++
    MouseEnterOutSimulator._add(this._uid, {
      el: element,
      handleMouseEnter,
      handleMouseLeave
    })
  }
  dispose() {
    MouseEnterOutSimulator._remove(this._uid)
  }
  static _add(uid, data) {
    MouseEnterOutSimulator._store.set(uid, data)
  }
  static _remove(uid) {
    MouseEnterOutSimulator._store.delete(uid)
  }
  static beginListen() {
    document.addEventListener('touchmove', MouseEnterOutSimulator._mousemoveListener)
  }
  static _mousemoveListener(e) {
    const currentCoords = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY
    }
    for (let data of MouseEnterOutSimulator._store.values()) {
      let wasCursorIn = isCursorInElement(MouseEnterOutSimulator._lastCoords, data.el)
      let isCursorIn = isCursorInElement(currentCoords, data.el)
      if (isCursorIn && !wasCursorIn) {
          data.handleMouseEnter()
          break
      }
      if (!isCursorIn && wasCursorIn) {
          data.handleMouseLeave()
          break
      }
    }
    MouseEnterOutSimulator._lastCoords.x = currentCoords.x
    MouseEnterOutSimulator._lastCoords.y = currentCoords.y
  }
}
MouseEnterOutSimulator._store = new Map()
MouseEnterOutSimulator._uid = 0
MouseEnterOutSimulator._lastCoords = {
  x: 0,
  y: 0
}

MouseEnterOutSimulator.beginListen()

window.__XES_GLOBAL__ = {}
window.__XES_GLOBAL__.sendClassWorkCheckLog = sendClassWorkCheckLog
export {
  Base64,
  sliceObject,
  serializeObject,
  isNumber,
  genFullScreenLayer,
  disableSafariScale,
  isCursorInElement,
  MouseEnterOutSimulator
}
